import { FC } from 'react';
import { IRTERenderElementProps } from '../../../../../../RTEEditable.interfaces';

export const TableHeadElement: FC<IRTERenderElementProps> = (props) => {
  const { element, children } = props;
  const attributes = props.attributes ?? {};

  return (
    <th
      {...element.attr}
      {...attributes}
      style={{
        border: '1px solid #272522',
        height: '50px',
        padding: '0 5px',
        overflowWrap: 'anywhere',
      }}
    >
      {children}
    </th>
  );
};
